// First, so HeyCatch starts before anything renders (Hollerpost build only;
// a no-op module elsewhere, see vite.config.js).
import 'virtual:hp-heycatch'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './theme.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
